<template>
	<div>
		<el-form
			:rules="rules"
			ref="customForm"
			label-position="top"
			label-width="80px"
			:model="customObj"
			class="customForm"
		>
			<el-form-item label="附加链接文字" prop="showText">
				<el-input v-model="customObj.showText"></el-input>
			</el-form-item>
			<el-form-item label="最终达到网站" prop="pagePath">
				<el-input v-model="customObj.pagePath" :disabled="isCustom"></el-input>
			</el-form-item>
			<el-form-item label="附加链接说明一(建议添加)" prop="explain1">
				<el-input v-model="customObj.explain1"></el-input>
			</el-form-item>
			<el-form-item label="附加链接说明二(建议添加)" prop="explain2">
				<el-input v-model="customObj.explain2"></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	props: {
		customObj: {
			type: Object,
			default: function () {
				return {
					showText: '',
					pagePath: '',
					explain1: '',
					explain2: '',
				};
			},
		},
		isCustom: {
			type: Boolean,
			default: true,
		},
		choose: Array,
	},
	data() {
		let that = this;
		var validateShowTextContent = (rule, value, callback) => {
			let callbackText = '';
			function countOccurrences(val) {
				let chooseCopy = that.choose.filter(item => {
					return item.content != that.customObj.content;
				});
				let resArr = chooseCopy.map(item => {
					return {
						content: item.content,
						res: item.showText.trim() == val.trim(),
					};
				});
				let res = resArr.filter(item => item.res);
				if (res.length != 0) {
					callbackText = res.map(item => item.content).join('，');
					return true;
				}
				return false;
			}

			if (value) {
				if (countOccurrences(value)) {
					callback(new Error(`不可与${callbackText}的附加链接文字相同`));
				} else {
					callback();
				}
			}
			callback();
		};
		var validatePagePath = (rule, value, callback) => {
			let domain = this.customObj.domain;
			let reg = /^https:\/\//;
			if (value === '') {
				callback(new Error('请输入最终达到网站'));
			} else if (!reg.test(value) || value.search(domain) == -1) {
				callback(new Error('请输入正确的网站主域名'));
			} else {
				callback();
			}
		};
		var validateSize = (rule, value, callback) => {
			if (value && that.strlength(value) > rule.rule) {
				callback(new Error(`字符限制为${rule.rule}个字符`));
			} else {
				callback();
			}
		};
		var validateExplain = (rule, value, callback) => {
			if (!that.customObj[rule.field] && that.customObj[rule.rule]) {
				callback(new Error('附加链接说明一与附加链接说明二需全部设置'));
			} else {
				callback();
			}
		};
		let validateContent = (rule, value, callback) => {
			if (value && that.customObj[rule.rule]) {
				if (value.trim() == that.customObj[rule.rule].trim()) {
					callback(new Error('附加链接说明一与附加链接说明二不可重复'));
				} else {
					callback();
				}
			}
			callback();
		};
		return {
			rules: {
				showText: [
					{ required: true, message: '请输入附加链接文字', trigger: 'change' },
					{ validator: validateSize, trigger: 'blur', rule: 25 },
					{ required: false, validator: validateShowTextContent, trigger: 'blur' },
				],
				pagePath: [{ required: true, validator: validatePagePath, trigger: 'blur' }],
				explain1: [
					{ required: false, validator: validateSize, trigger: 'blur', rule: 35 },
					{ required: false, validator: validateExplain, trigger: 'blur', rule: 'explain2' },
					{ required: false, validator: validateContent, trigger: 'blur', rule: 'explain2' },
				],
				explain2: [
					{ required: false, validator: validateSize, trigger: 'blur', rule: 35 },
					{ required: false, validator: validateExplain, trigger: 'blur', rule: 'explain1' },
					{ required: false, validator: validateContent, trigger: 'blur', rule: 'explain1' },
				],
			},
		};
	},
	methods: {
		strlength(txt) {
			let temp = 0;
			for (let i = 0; i < txt.length; i++) {
				if (/[^\x00-\xff]/.test(txt[i])) {
					temp += 2;
				} else {
					temp++;
				}
			}
			return temp;
		},
	},
};
</script>

<style lang="scss" scoped>
.customForm ::v-deep .el-form-item {
	margin: 0px;
	.el-form-item__label {
		line-height: 0px;
		margin-top: 25px;
		margin-bottom: 5px;
	}
}
</style>
